/*
 * Copyright © 2020-2022 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: jiakaiwen jiakaiwen@huihaiyinhe.com
 * @LastEditTime: 2026-01-27 14:21:29
 */
import React, { useEffect } from 'react'
import { useAppSelector, useAppDispatch } from '../../app/hooks'
import { Layout, Spin } from 'antd'
import { AntdProvider } from '@/components/AntdProvider'
import SideComponent from './SideComponent'
import DownloadClientDialog from '../components/DownloadClientDialog'

import DownloadSetting from '../components/desktop/DownloadSetting'
import VipPaymentModal from '../components/VipPaymentModal'
import Payment from '../components/PaymentV2'
import AiChatDrawer from '../components/AiChatDrawer'
import Header from './Header'
import OperationModal from '../components/OperationModal'
import CreateRectifyDrawer from '../components/CreateRectifyDrawer'
import HooksBridge from './HooksBridge'

import { abtest } from '../../utils/sensors'
import actionTypes from '../../constants/actionTypes'

function MainWrapper(props) {
  const { children } = props
  const dispatch = useAppDispatch()
  const loading = useAppSelector((state) => state.main.loading)

  // 加载所有 AB 测试配置
  useEffect(() => {
    // 照片变清晰 AB 测试
    abtest.fastFetchABTest({
      param_name: 'PhotoEnhancementAB',
      default_value: false,
      value_type: 'Boolean',
      callback: (res) => {
        dispatch({
          type: actionTypes.SET_AB_TEST_CONFIG,
          data: {
            PhotoEnhancementAB: res
          }
        })
      }
    })

    // 建筑安全识别 AB 测试
    abtest.fastFetchABTest({
      param_name: 'construction_safety',
      default_value: {},
      value_type: 'Object',
      callback: (data) => {
        dispatch({
          type: actionTypes.SET_AB_TEST_CONFIG,
          data: {
            buildingSafetyAIModelName: data.modelName,
            buildingSafetyEntries: data.pagePosition || [],
            buildingSafetyIndustryCode: data.industryCode || []
          }
        })
      }
    })

    // 批量编辑水印按钮 AB 测试
    abtest.fastFetchABTest({
      param_name: 'WatermarkBatchEditor',
      default_value: false,
      value_type: 'Boolean',
      callback: (res) => {
        dispatch({
          type: actionTypes.SET_AB_TEST_CONFIG,
          data: {
            WatermarkBatchEditor: res
          }
        })
      }
    })
  }, [dispatch])

  if (
    /^\/photo\/folder\/add\/\d+/.test(window.location.pathname) ||
    /^\/photo\/picker\??[^/]*$/.test(window.location.pathname) ||
    /^\/watermark\/batchEditor/.test(window.location.pathname) ||
    /^\/today-claw/.test(window.location.pathname) ||
    /^\/native-claw-pro/.test(window.location.pathname)
  ) {
    return (
      <>
        {children}
        <VipPaymentModal />
        <Payment />
        <HooksBridge />
      </>
    )
  }

  return (
    <AntdProvider>
      <Spin spinning={loading} size="large" className="loading">
        <Layout>
          <Header />
          <Layout id="main-content" style={{ minHeight: 'calc(100vh - 70px)' }}>
            <SideComponent />
            {children}
          </Layout>
          {/* Web端邀请使用客户端弹窗 */}
          <DownloadClientDialog />
          {/* 桌面端设置下载位置 和 下载完打开目录 弹窗 */}
          <DownloadSetting />

          {/* 运营弹窗 */}
          <OperationModal />

          <VipPaymentModal />
          <Payment />
          <AiChatDrawer />
          {/* 发起整改抽屉 */}
          <CreateRectifyDrawer />
          {/* 桥接 hooks */}
          <HooksBridge />
        </Layout>
      </Spin>
    </AntdProvider>
  )
}

export default MainWrapper
